define('Components/Vod/js/views/VodSidedishView',['app','views/blocks/SidedishView',
    'template!Components/Vod/templates/sidedishes-vod',
    'BtnSwitchView'
],function(app,SidedishView,sidedishBlockTemplate,BtnSwitchView){
    return SidedishView.extend({
        getSteps:function(){
            console.log('getSteps VODSidedishView');
            var category = app.getCategory(app.c('_VOD_CATEGORY_ID_')),
                products = category.getProducts(),
                slug = 'vod',
                title = false; //app.t('Envie de Vod ?','Vod',category.getName());

                return [{
                    categorySlug: slug,
                    key: slug,
                    inputType: 'btn-switch',
                    sidedish:false,
                    title: title,
                    products: products,
                    template:sidedishBlockTemplate
                }];
        },
    });
});
